import axios from 'axios'
import authHeader from '../security/auth.header'

const API_URL = process.env.VUE_APP_BASE_API_URL + '/api/v1/admin/customers'
const API_URL_EMPLOYEE = process.env.VUE_APP_BASE_API_URL + '/api/v1/employee/customers'

class CustomerApi {
  getList(page, size, tableFilters) {
    let filterString = ''
    tableFilters.forEach(
      e => (filterString += '&filter[' + e.field + ']=' + e.value)
    )
    return axios.get(
      API_URL + '?actualPage=' + page + '&perPage=' + size + filterString,
      {
        headers: authHeader()
      }
    )
  }

  employeeGetList(page, size, tableFilters) {
    let filterString = ''
    tableFilters.forEach(
      e => (filterString += '&filter[' + e.field + ']=' + e.value)
    )
    return axios.get(
      API_URL_EMPLOYEE + '?actualPage=' + page + '&perPage=' + size + filterString,
      {
        headers: authHeader()
      }
    )
  }

  getDetail(uuid) {
    return axios.get(API_URL + '/' + uuid, { headers: authHeader() })
  }

  employeeGetDetail(uuid) {
    return axios.get(API_URL_EMPLOYEE + '/' + uuid, { headers: authHeader() })
  }
}

export default new CustomerApi()
